export const CancelSuccessModal: string = 'CancelSuccessModal';
